module.exports = __webpack_public_path__ + "public-ui/img/akcept.49d799d2.svg";